function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import { StyledBoardViewsComponent, StylesLottieItemWrapper } from "./board-views-component.scss";
import LottieComponent from "/components/core/lottie/lottie-component";
const BOARD_VIEWS_ANIMATIONS = [
    {
        jsonPath: "/static/lottie/board-views/calendar.json",
        title: "boardView.calendar",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/graph.json",
        title: "boardView.chart",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/files.json",
        title: "boardView.files",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/kanban.json",
        title: "boardView.kanban",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/map.json",
        title: "boardView.map",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/timeline.json",
        title: "boardView.timeline",
        href: "/features"
    }
];
class BoardViewsComponent extends PureComponent {
    stopAnimation() {
        this.setState({
            playAnimation: null
        });
    }
    playAnimation(animation) {
        this.setState({
            playAnimation: animation
        });
    }
    renderAnimatedGallery() {
        const { translate } = this.props;
        return BOARD_VIEWS_ANIMATIONS.map((lottieAnimation)=>{
            const shouldPlay = this.state.playAnimation === lottieAnimation.jsonPath;
            return /*#__PURE__*/ _jsx(StylesLottieItemWrapper, {
                className: "lottie-item-wrapper",
                onMouseEnter: this.playAnimation.bind(this, lottieAnimation.jsonPath),
                onMouseLeave: this.stopAnimation,
                children: /*#__PURE__*/ _jsxs("a", {
                    href: lottieAnimation.href,
                    children: [
                        /*#__PURE__*/ _jsx(LottieComponent, {
                            jsonPath: lottieAnimation.jsonPath,
                            autoplay: false,
                            shouldPlay: shouldPlay,
                            shouldPause: !shouldPlay,
                            loop: true
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "board-view-item-text",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "board-view-item-title",
                                children: translate(lottieAnimation.title)
                            })
                        })
                    ]
                })
            }, lottieAnimation.jsonPath);
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(StyledBoardViewsComponent, {
            className: "board-views-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "paragraph-with-logos-wrapper",
                    children: /*#__PURE__*/ _jsx(ParagraphComponent, _object_spread({}, this.props.paragraph))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "lottie-gallery-wrapper",
                    children: this.renderAnimatedGallery()
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            playAnimation: null
        };
        this.stopAnimation = this.stopAnimation.bind(this);
    }
}
export { BoardViewsComponent as default };
BoardViewsComponent.defaultProps = {
    paragraph: {
        topic: {
            text: "Plan and track visually",
            color: "brand-red"
        },
        title: "Know where everything stands",
        body: [
            "Track all your team work and know where everything stand in a glance.",
            "Choose the best view for you that will boost your productivity."
        ],
        textDirection: "center"
    }
};
